import { render, staticRenderFns } from "./CaptureUpload.vue?vue&type=template&id=20d35f8a"
import script from "./CaptureUpload.vue?vue&type=script&lang=js"
export * from "./CaptureUpload.vue?vue&type=script&lang=js"
import style0 from "./CaptureUpload.vue?vue&type=style&index=0&id=20d35f8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports